/* eslint-disable no-console */

/**
 * TODO ( ionutt )
 * If you want to suppress base on the environment, we should show
 * the console from PWA SW, so the last arguments of this function should be
 * thread as an "force" parameter.
 */

export default {
    log() {
        console.log.apply(null, arguments);
    },
    debug() {
        console.debug.apply(null, arguments);
    },
    warn() {
        console.warn.apply(null, arguments);
    },
    error() {
        console.error.apply(null, arguments);
    },
    critical() {
        console.critical.apply(null, arguments);
    },
};
